import { render, staticRenderFns } from "./CommunityHubCard.vue?vue&type=template&id=371eba1c&"
import script from "./CommunityHubCard.vue?vue&type=script&lang=ts&"
export * from "./CommunityHubCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports